import { useState, useEffect, useCallback } from "react";
import { DdSites } from "../api";

const ddSitesApi = new DdSites();

export const FALLBACK_SITES = [
  { id: "ba", flag: "AR", name: "Buenos Aires", country: "Argentina", headcount: 1214 },
];

/**
 * Lista de sitios compartida entre los módulos OCDE de Debida Diligencia
 * (Autoevaluación, Risk Register, CAP Tracker). Agregar/quitar un sitio en
 * cualquiera de los 3 módulos se refleja en los otros.
 *
 * onAdd/onRemove permiten que cada módulo reconcilie su propia estructura
 * de datos (ej. generar entradas de madurez por defecto para un sitio nuevo).
 */
export function useDdSites(accessToken, { onAdd, onRemove } = {}) {
  const [sites, setSites] = useState(FALLBACK_SITES);
  const [loading, setLoading] = useState(true);
  // Si la carga falla, los módulos no deben mostrar ni guardar FALLBACK_SITES:
  // agregar una sede guardaría [ejemplo, nueva] encima de la lista real.
  const [error, setError] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    if (!accessToken) return;
    setLoading(true);
    setError(false);
    ddSitesApi.getData(accessToken)
      .then((d) => { if (d?.length) setSites(d); })
      .catch((err) => { console.error("Error cargando sitios", err); setError(true); })
      .finally(() => setLoading(false));
  }, [accessToken, reloadKey]);

  const reloadSites = useCallback(() => setReloadKey((k) => k + 1), []);

  const persist = useCallback((next) => {
    setSites(next);
    if (accessToken) ddSitesApi.saveData(accessToken, next).catch((err) => console.error("Error guardando sitios", err));
  }, [accessToken]);

  const addSite = useCallback((site) => {
    setSites((prev) => {
      const next = [...prev, site];
      if (accessToken) ddSitesApi.saveData(accessToken, next).catch((err) => console.error("Error guardando sitios", err));
      return next;
    });
    onAdd?.(site);
  }, [accessToken, onAdd]);

  const removeSite = useCallback((siteId) => {
    setSites((prev) => {
      const next = prev.filter((s) => s.id !== siteId);
      if (accessToken) ddSitesApi.saveData(accessToken, next).catch((err) => console.error("Error guardando sitios", err));
      return next;
    });
    onRemove?.(siteId);
  }, [accessToken, onRemove]);

  return { sites, sitesLoading: loading, sitesError: error, reloadSites, addSite, removeSite, persistSites: persist };
}
